import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  siteName: "Asian Picks",
  domain: "https://asian-picks.com",
  image: "https://asian-picks.com/og-image.png",
  keywords:
    "Asian Handicap tips, Asian Handicap predictions, AH football tips, football predictions, verified football tipsters, soccer handicap predictions, football betting tips, Asian Picks",
};

/**
 * Per-page SEO / Open Graph tags.
 * Pass a page-specific title, description, path (e.g. "/pricing"), and optional keywords.
 */
export default function SEO({
  title,
  description,
  path = "/",
  keywords,
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} | ${DEFAULTS.siteName}`
    : `${DEFAULTS.siteName} — Professional Asian Handicap Football Tips & Predictions`;
  const url = `${DEFAULTS.domain}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || DEFAULTS.keywords} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:image" content={DEFAULTS.image} />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULTS.image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
